/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import { fetchMandate } from '../../lib/rest/mandateAPIClient'
import MandateForm from './MandateForm'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import useParsedQueryParam from '../../../../client/js/hooks/useParsedQueryParam'
import { parseNumber } from '@jalik/form-parser'
import Page from '../../../../client/js/components/Page'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'
import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import { getMandateListLink } from '../../lib/links/mandateLinks'
import { getMandateReference } from '../../lib/common/mandate.mjs'

function MandateFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const mandateId = parseInt(params.id, 10)
  const [searchParams] = useQueryParams()
  const customerId = useParsedQueryParam('customerId', parseNumber)
  const estateId = useParsedQueryParam('estateId', parseNumber)

  const mandateQuery = useQuery({
    enabled: true,
    queryKey: ['mandate', mandateId, searchParams],
    queryFn: () => mandateId > 0
      ? fetchMandate(mandateId)
      : Promise.resolve({
        customerId,
        MandateAndEstate: estateId ? [{ estateId }] : []
      } as Partial<Mandate>),
    refetchOnWindowFocus: false
  })
  const { data } = mandateQuery

  const title = mandateId > 0 && data != null
    ? getMandateReference(data)
    : intl.formatMessage({
      id: 'create_mandate',
      defaultMessage: 'Créer un mandat'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
            <AnchorLink to={getMandateListLink()}>
              <FormattedMessage
                id="mandates"
                defaultMessage="Mandats"
              />
            </AnchorLink>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <Card shadow="sm">
          <LoadingHelper
            query={mandateQuery}
            render={() => (
              <MandateForm initialValues={data} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default MandateFormPage
